import styles from "./styles/error-modal.module.scss";
import errorIcon from "@/assets/icons/error-icon.svg";
import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";
import Image from "next/image";
import Link from "next/link";
import { useContactSupportContext } from "@/components/pages/contact/context/contact-support-context";
import { useEffect } from "react";

type FeedbackData = {
  attachedFile?: File;
  message?: string;
  subject?: string;
};

type Props = {
  title?: string;
  message?: string;
  feedbackData?: FeedbackData;
};

const ErrorModal = ({ title, message, feedbackData }: Props) => {
  const { hideModal } = useGlobalModalContext();
  const { setData } = useContactSupportContext();

  useEffect(() => {
    if (feedbackData) {
      setData(feedbackData);
    }
  }, []);

  const modalTitle = title ?? "Something went wrong";

  return (
    <div className={styles.wrapper}>
      <div className={styles.header_wrapper}>
        <Image src={errorIcon} alt="error" />
        <div className={styles.title}>{modalTitle}</div>
        {message && <div className={styles.message}>{message}</div>}
      </div>
      <div className={styles.footer_wrapper}>
        <div>If you have an issue, please contact us</div>
        <Link
          className={styles.contact_button}
          href={"/help/contact"}
          onClick={hideModal}
        >
          Contact Us
        </Link>
      </div>
    </div>
  );
};

export default ErrorModal;
